<template>
  <div>
    <div class="header-search">
      <van-field
        v-model="value1"
        right-icon="search"
        placeholder="请输入产品名称"
      />
      <div class="search-icon" @click.prevent="onSearch"></div>
    </div>
    <div class="product-swipe">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <van-swipe-item v-for="(item,index) in swipeImg1" :key="index">
          <!-- <svg-icon :icon-class="item.img"></svg-icon> -->
          <img :src="item.img" alt />
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="product-list">
      <ul class="product-nav">
        <li
          v-for="(item,index) in liList"
          :key="index"
          :class="isLink==item.id ? 'li-style li-check-style' : 'li-style'"
          @click="chooseLi(item,index)"
        >
          {{item.name}}
          <svg-icon v-if="isLink==item.id" icon-class="home_line2"></svg-icon>
        </li>
      </ul>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list v-model="loading" :key="onlyKey" :offset=1 :finished="finished" finished-text="没有更多了" @load="onLoad">
          <div class="pro-list-list" v-for="(item,index) in newDataList" :key="index">
            <div v-if="level=='热门'">
              <div class="product-type-title">{{item.name}}</div>
              <div v-if="item.name=='贷款'">
                <div
                  class="bank-list"
                  v-for="(c,i) in item.list"
                  :key="i"
                  @click.prevent="checkData(c)"
                >
                  <div class="list-com bank-top">
                    <div class="bank-top-left">
                      <div class="bank-top-left-img">
                        <img :src="c.thumbnail" alt />
                      </div>
                      <div>
                        <p class="product-list-title">{{c.name}}</p>
                        <p class="product-list-summary">手续简单抵押率高</p>
                      </div>
                    </div>
                    <div class="bank-top-right">
                      <svg-icon icon-class="product_but"></svg-icon>
                    </div>
                  </div>
                  <div class="list-com bank-bottom">
                    <p v-html="c.digest"></p>
                  </div>
                </div>
              </div>
              <div v-else>
                <div
                  class="bank-list product-safe"
                  v-for="(t,ii) in item.list"
                  :key="ii"
                  @click.prevent="checkData(t)"
                >
                  <div class="product-safe-left">
                    <img :src="t.thumbnail" alt />
                  </div>
                  <div class="product-safe-right">
                    <div>
                      <p class="product-list-title">{{t.name}}</p>
                      <div class="safe-right-height">
                        <p v-html="t.digest" class="product-list-summary"></p>
                      </div>
                      <div class="bank-top-right safe-right-but">
                        <svg-icon icon-class="product_but"></svg-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="product-type-title">{{item.name}}</div>
              <div v-if="level=='贷款'">
                <div
                  class="bank-list"
                  v-for="(tt,ind) in item.list"
                  :key="ind"
                  @click.prevent="checkData(tt)"
                >
                  <div class="list-com bank-top">
                    <div class="bank-top-left">
                      <div class="bank-top-left-img">
                        <img :src="tt.thumbnail" alt />
                      </div>
                      <div>
                        <p class="product-list-title">{{tt.name}}</p>
                        <p class="product-list-summary">手续简单抵押率高</p>
                      </div>
                    </div>
                    <div class="bank-top-right">
                      <svg-icon icon-class="product_but"></svg-icon>
                    </div>
                  </div>
                  <div class="list-com bank-bottom">
                    <p v-html="tt.digest"></p>
                  </div>
                </div>
              </div>
              <div v-if="level!='贷款'">
                <div
                  class="bank-list product-safe"
                  v-for="(yy,o) in item.list"
                  :key="o"
                  @click.prevent="checkData(yy)"
                >
                  <div class="product-safe-left">
                    <img :src="yy.thumbnail" alt />
                  </div>
                  <div class="product-safe-right">
                    <div>
                      <p class="product-list-title">{{yy.name}}</p>
                      <div class="safe-right-height">
                        <p v-html="yy.digest" class="product-list-summary"></p>
                      </div>
                      <div class="bank-top-right safe-right-but">
                        <svg-icon icon-class="product_but"></svg-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import URL from '@/api/api'
import URLTB from "@/api/apiTB";
import { Toast, Dialog } from 'vant'
import { setLocal } from "@/utils/utils";
export default {
  data() {
    return {
      value1: '',
      isLink: '',
      level: '热门',
      active: '热门',
      loading: false,//加载中
      finished: false,//是否已加载完成
      refreshing: false,//下拉刷新
      productList: [],
      newDataList: [],
      productListShow: [],
      value: this.$route.query.value,
      onlyKey:new Date().getTime(),
      search: '',
      swipeImg1: [
        { img: require('./img/product_banner.png') },
      ],
      liList: [],
      page: 1,//当前页数
      size: 12,//每页数量
      total: 0,
      hotProduct:'1'
    }
  },
  mounted() {
    this.getProductType()
    this.getType()
    // this.getData()
  },

  methods: {
    //首页跳转产品库类型锁定
    getType(){
      let value = this.$route.query.value
      if(value){
        this.isLink=value
      }
    },
    getProductType() {
      this.$fetchGet(URL.ProductType.url).then(res => {
        // this.liList=res.data.data
        let list = []
        res.data.data.forEach(it => {
          if (it.name === '贷款') {
            list.push(it)
          }
        })
        list.unshift({ id: '', name: '热门' })
        this.liList = list
      })
    },
    onRefresh() {
      let that = this
      // console.log(this.refreshing);
      that.finished = false;
      that.page = 1
      that.loading = true;
      that.getData();
    },
    onLoad() {
      this.getData();
    },
    getData() {
      let that = this
      let data = {
        hot:that.hotProduct,
        idProductType: that.isLink,
        param: that.value1,
        page: that.page,
        size: that.size,
        createCompany: 'ZFKJ'
      }
      that.$fetchGet(URLTB.ProductTypeList.url, data).then(res => {
        that.refreshing = false;
        that.loading = false;
        that.total = res.data.data.total;
        let list = res.data.data.records;
        let bxList = []
        if (list == null || list.length === 0) {
          // 加载结束
          that.finished = true;
          that.newDataList = []
          return;
        }
        // 将新数据与老数据进行合并
        if (that.page > 1) {
          that.productList = [...that.productList, ...list]
        } else {
          that.productList = list
        }
        //如果列表数据条数>=总条数，不再触发滚动加载
        if (that.productList.length >= that.total) {
          that.finished = true;
        }
        //说明可能还有下一页
        if (that.productList.length < that.total) {
          that.page++;
        }

        that.productList.map((item, index, x) => {
          if (item.idProductType == 13) {
            let data = {
              name: '贷款',
              list: x.filter(y => y.idProductType == 13) || []
            }
            bxList.push(data)
            // console.log(x);
          } else if (item.idProductType == 14) {
            let data = {
              name: '教育',
              list: x.filter(y => y.idProductType == 14) || []
            }
            bxList.push(data)
          } else if(item.idProductType == 11){
            let data1 = {
              name: '保险',
              list: x.filter(y => y.idProductType == 11) || []
            }
            bxList.push(data1)
          }
        })
        that.newDataList = that.delRemoval(bxList).reverse()//倒叙排列
      })
    },
    delRemoval(arr2) {
      var temp = [];
      arr2.forEach(function (a) {
        var check = temp.every(function (b) {
          return a.name !== b.name;
        })
        check ? temp.push(a) : ''
      })
      return temp;
    },
    chooseLi(item, i) {
      this.isLink = item.id
      this.level = item.name
      if(this.level=='热门'){
        this.hotProduct='1'
      }else{
         this.hotProduct='0'
      }
      this.page = 1
      this.finished = false
      this.newDataList=[]
      this.productList=[]
      this.onlyKey=new Date().getTime()
    },
    checkData(ctim) {
      var authFlag = localStorage.getItem('authFlag') || null
      var buyFlag = localStorage.getItem('buyFlag') || null
      let isLogin = localStorage.getItem("isLogin")
      if (authFlag == '0' || authFlag == null || authFlag ==undefined || authFlag =='undefined') {
        // Toast('未实名认证')
        Dialog.alert({
          message: '请前往，我的->个人中心->其他服务，下进行实名认证',
        }).then(() => {
          // on close
        });
      } else if (isLogin != '1') {
        this.$router.push('/login')
      } else {
        console.log(ctim);
        setLocal('img', ctim.img)
        setLocal('Qimg', ctim.qrCode)
        setLocal('Simg', ctim.consultCode)
        setLocal('productId', ctim.id)
        this.$router.push({ path: '/showBusiness', query: { id: ctim.id } })
      }

    },
    onSearch() {
      let that = this
      // console.log(this.refreshing);
      that.finished = false;
      that.page = 1
      that.loading = true;
      that.getData()
    },
  }
}
</script>

<style lang="less" scoped>
.header-search {
  width: 355px;
  height: 30px;
  margin: auto;
  position: relative;
  .van-cell{
    width: 355px;
    height: 30px;
    line-height: 30px;
    padding: 0 10px;
    border-radius: 5px;
    border: 1px solid #fc6e09;
  }
  .search-icon{
    width: 25px;
    height: 25px;
    margin-left:3px;
    position: absolute;
    right: 3px;
    top: 1px;
  }
}
.product-swipe {
  width: 355px;
  margin: 11px auto 0 auto;
  img {
    width: 355px;
    height: 80px;
  }
}
.product-list {
  width: 375px;
  margin-bottom: 32.5px;
  p {
    font-family: PingFang SC;
    color: #333333;
  }
  .product-list-title {
    width: 115px;
    height: 20px;
    overflow: hidden;
    margin: 12px 0 8px 18px;
    font-size: 14px;
    font-weight: Bold;
  }
  .product-list-summary {
    width: 115px;
    height: 14.5px;
    margin-left: 18px;
    font-size: 10.5px;
    font-weight: Regular;
    overflow: hidden;
  }
  .product-common-title {
    margin-top: 22px;
  }
  .product-nav {
    width: 375px;
    height: 48.5px;
    align-items: center;
    display: flex;
    justify-content: space-around;
    margin-top: 12.5px;
    background: url("./img/product_bg.png") no-repeat 100%;
    background-size: 100%;
    .svg-icon {
      width: 13.5px;
      height: 2px;
      display: block;
      //   margin-left: 5.5px;
      //   margin-top: 2.5px;
      margin: 2.5px auto 0 auto;
    }
    .li-style {
      //   width: 28.5px;
      font-size: 14px;
      font-family: PingFang SC;
      color: #333333;
      font-weight: Medium;
    }
    .li-check-style {
      font-weight: Regular;
      color: #fc6e09;
    }
  }
  .pro-list-list {
    width: 355px;
    margin: 15.5px auto 0 auto;
    .product-type-title {
      margin-left: 10px;
      font-size: 16px;
      font-weight: Bold;
      color: #333333;
    }
    .bank-list {
      width: 355px;
      //   height: 153.5px;
      margin-top: 15.5px;
      padding: 10.5px 0 9.5px 0;
      background: #ffffff;
      border-radius: 10px;
      //   background: url('./img/product_bg1.png') no-repeat 100%;
      //   background-size: 100% 100% ;
      .list-com {
        width: 335px;
        margin: auto;
      }
      .bank-top,
      .bank-top-left {
        height: 65px;
        display: flex;
        .bank-top-left-img {
          width: 128px;
          height: 65px;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .bank-top {
        justify-content: space-between;
        align-items: center;
      }
      .bank-top-right {
        .svg-icon {
          width: 62px;
          height: 24.5px;
        }
      }
      .bank-bottom {
        height: 56.5px;
        margin-top: 12px;
        line-height: 1.5;
        overflow: hidden;
        p {
          height: 14px;
          padding-left: 17.5px;
          font-size: 10px;
        }
      }
    }
    .product-safe {
      height: 135px;
      padding: 0;
      align-items: center;
      display: flex;
      .product-safe-left {
        width: 128px;
        height: 110px;
        margin-left: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .product-safe-right {
        // border: 1px solid;
        width: 195.5px;
        height: 110px;
        margin-left: 11.5px;
        position: relative;
        .safe-right-but {
          position: absolute;
          bottom: 0;
          right: 0;
        }
        .safe-right-height {
          height: 48px;
          overflow: hidden;
        }
        .product-list-summary {
          width: auto;
          height: auto;
          margin-top: 2px;
          margin-left: 0;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .product-list-title {
          width: auto;
          margin: 0;
          overflow: inherit;
          display: inline-block;
        }
      }
    }
  }
}
</style>